import React from 'react';
import type { Editor } from 'ckeditor5';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { OEToggle } from '../../../../../../global/oe-toggle/oe-toggle';
import Text from '../../../../../../global/text/text';
import { FormField } from '../../../../../../global/form/form-field/form-field';
import { RichTextEditor } from '../../../../../../global/rich-text-editor';
import { EnablementStatus } from '../../../../../../../constants/common.constants';
import { LOADING } from '../../../../../../../constants/common-labels.constants';
import {
    HUB_FOOTER_POWERED_BY_TOGGLE_TEXT,
    HUB_FOOTER_TEXT_LABEL_TEXT,
} from '../../../../../event-hubs.text';
import { HubFooterSettingsVM } from './hub-footer-settings.viewmodel';
import './hub-footer-settings.scss';

type HubFooterSettingsProps = {
    vm: HubFooterSettingsVM;
};

export const HubFooterSettings: React.FC<HubFooterSettingsProps> = observer(({ vm }) => {
    if (vm.isLoading()) {
        return (
            <div className='hub-footer-settings__loading'>
                <FormattedMessage {...LOADING} values={{ suffix: '...' }} />
            </div>
        );
    }

    return (
        <div className='hub-footer-settings'>
            <FormField
                className='hub-footer-settings__field'
                label={<FormattedMessage {...HUB_FOOTER_TEXT_LABEL_TEXT} />}
            >
                <RichTextEditor
                    className='oe-form-field__control m-0px p-0px'
                    value={vm.getFooterText()}
                    onChange={(_: unknown, editor: Editor) => vm.setFooterText(editor.getData())}
                    validationError={vm.getFooterTextError() || undefined}
                    dataTestId='hub-footer-text'
                />
            </FormField>

            <div className='hub-footer-settings__toggle-row'>
                <OEToggle
                    isSelected={vm.isPoweredByLogoDisplayed()}
                    onClick={vm.togglePoweredByLogo}
                    dataTestId='toggle-hub-footer-powered-by'
                />
                <Text
                    message={vm.intl.formatMessage(HUB_FOOTER_POWERED_BY_TOGGLE_TEXT, {
                        suffix: vm.isPoweredByLogoDisplayed() ? EnablementStatus.DISPLAYED : EnablementStatus.NOT_DISPLAYED,
                    })}
                />
            </div>
        </div>
    );
});
